import type { Template } from "@/types";

export const LA_06_H2_V4: Template[] = [
    {
        id: "la-06-h2v4-01",
        name: "LA 01 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 65, y: 54, width: 256, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 54, width: 282, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 276, width: 282, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 790, y: 54, width: 294, height: 435, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1092, y: 54, width: 150, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1092, y: 276, width: 150, height: 213, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-02",
        name: "LA 02 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 174, y: 36, width: 329, height: 470, rotation: 0, imageRotation: 0 },
            { id: "2", x: 788, y: 36, width: 334, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 275, width: 334, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1130, y: 36, width: 117, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1130, y: 196, width: 117, height: 151, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1130, y: 355, width: 117, height: 151, rotation: 0, imageRotation: 0 } 
        ],
    },

    {
        id: "la-06-h2v4-03",
        name: "LA 03 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_03.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 175, y: 54, width: 325, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 175, y: 274, width: 325, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 859, y: 54, width: 151, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 274, width: 151, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 54, width: 151, height: 212, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 274, width: 151, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-04",
        name: "LA 04 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_04.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 120, y: 51, width: 140, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 268, y: 51, width: 288, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 120, y: 275, width: 140, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 268, y: 275, width: 140, height: 215, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 275, width: 140, height: 215, rotation: 0, imageRotation: 0 },         
            { id: "6", x: 767, y: 93, width: 494, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-05",
        name: "LA 05 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 118, y: 50, width: 440, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 339, width: 105, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 230, y: 339, width: 105, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 339, width: 105, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 454, y: 339, width: 104, height: 152, rotation: 0, imageRotation: 0 },
            { id: "6", x: 767, y: 93, width: 494, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-06",
        name: "LA 06 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 65, y: 74, width: 477, height: 393, rotation: 0, imageRotation: 0 },            
            { id: "2", x: 550, y: 74, width: 124, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 550, y: 275, width: 124, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 682, y: 74, width: 124, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 682, y: 275, width: 124, height: 192, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 74, width: 474, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-07",
        name: "LA 07 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_07.png",
        size: [1352, 541],
        style: {},
        slots: [     
            { id: "1", x: 64, y: 74, width: 124, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 275, width: 124, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 196, y: 74, width: 477, height: 393, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 74, width: 125, height: 193, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 275, width: 125, height: 192, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 74, width: 474, height: 393, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-06-h2v4-08",
        name: "LA 08 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_08.png",
        size: [1352, 541],
        style: {},
        slots: [         
            { id: "1", x: 65, y: 74, width: 124, height: 193, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 275, width: 124, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 197, y: 74, width: 124, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 197, y: 275, width: 124, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 329, y: 74, width: 477, height: 393, rotation: 0, imageRotation: 0 },
            { id: "6", x: 814, y: 74, width: 474, height: 393, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-09",
        name: "LA 09 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 53, width: 527, height: 437, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 53, width: 138, height: 214, rotation: 0, imageRotation: 0 },
            { id: "3", x: 535, y: 276, width: 138, height: 214, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 53, width: 526, height: 437, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1215, y: 53, width: 137, height: 214, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1215, y: 276, width: 137, height: 214, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-06-h2v4-10",
        name: "LA 10 - H2V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-06-h2_v4_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 0, y: 74, width: 551, height: 395, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 559, y: 74, width: 114, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 559, y: 276, width: 114, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 681, y: 74, width: 113, height: 194, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 276, width: 113, height: 193, rotation: 0, imageRotation: 0 },
            { id: "6", x: 802, y: 74, width: 550, height: 395, rotation: 0, imageRotation: 0 }
        ],
    }
];